import { action, computed, observable } from 'mobx';
import { AudioRecorderUseMode } from '../_components/AudioRecorder/AbstractAudioView';

export class CommentEditState {
    @observable
    private _commentText = '';

    private _hasAudio = false; // ToDo: Store audio blob here instead of component and then just check if data exists

    private _audio?: Blob;
    private _audioLengthMs?: number;

    @observable
    private _recorderUseMode = AudioRecorderUseMode.Recording;

    @computed
    public get commentText(): string {
        return this._commentText;
    }

    @action
    public setCommentText(value: string): void {
        this._commentText = value;
    }

    public get audio(): Blob | undefined {
        return this._audio;
    }

    public get audioLengthMs(): number | undefined {
        return this._audioLengthMs;
    }

    public setAudio(audio: Blob, audioLengthMs: number): void {
        this._audio = audio;
        this._audioLengthMs = audioLengthMs;
    }

    @action
    public setHasAudio(value: boolean): void {
        this._hasAudio = value;
        if (value === false) {
            this._recorderUseMode = AudioRecorderUseMode.Recording;
        }
    }

    @computed
    public get recorderUseMode() {
        return this._recorderUseMode;
    }

    @action
    public setRecorderUseMode(value: AudioRecorderUseMode): void {
        this._recorderUseMode = value;
    }

    public get hasUnsubmittedData(): boolean {
        return this._hasAudio || this._commentText.trim() !== '';
    }
}



// WEBPACK FOOTER //
// ./src/Stores/CommentEditState.ts